/* eslint-disable consistent-return */
export const validElements = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'none'];
export default function headingLevel(props, propName, componentName) {
  const prop = `${props[propName]}`.toLowerCase();
  if (!validElements.includes(prop)) {
    return new Error(`Invalid prop ${propName} passed to ${componentName}. Expected one of h1, h2, h3, h4, h5, h6, none. Received: ${props[propName]}`);
  }
}